import {
    LOGGED_IN, SET_CALENDAR_PAGE_FILTER,
    SET_WAGES_TABLE_FILTER,
    SET_WAGES_PARAMS_SELECTION_MODE_ENABLED, setWagesParamsSelectionModeEnabled
} from "./actions";
import {LOCAL_STORAGE_KEYS} from "../components/shared/constants";


const settingsMiddleware = store => (next) => (action) => {
    if (action.type === LOGGED_IN) {
        let value1 = localStorage.getItem(LOCAL_STORAGE_KEYS.WAGES_TABLE_PAGE_SETTINGS);

        if (value1) {
            value1 = JSON.parse(value1);
            store.dispatch({ type: SET_WAGES_TABLE_FILTER, payload: value1 });
            // yes, we rewrite the value in localStorage one time on login, it's wrong, but so convenient
        }

        let value2 = localStorage.getItem(LOCAL_STORAGE_KEYS.WAGES_CALENDAR_PAGE_SETTING);

        if (value2) {
            value2 = JSON.parse(value2);
            store.dispatch({ type: SET_CALENDAR_PAGE_FILTER, payload: value2 });
            // yes, we rewrite the value in localStorage one time on login, it's wrong, but so convenient
        }

        let value3 = localStorage.getItem(LOCAL_STORAGE_KEYS.WAGES_PARAMS_SELECTION_MODE_ENABLED);
        if (value3) {
            value3 = JSON.parse(value3);
            store.dispatch({ type: SET_WAGES_PARAMS_SELECTION_MODE_ENABLED, payload: value3 });
            // yes, we rewrite the value in localStorage one time on login, it's wrong, but so convenient
        }
    }

    const result = next(action);

    if (action.type === SET_WAGES_TABLE_FILTER) {
        const values = store.getState().wagesEngineersTablePage;
        localStorage.setItem(LOCAL_STORAGE_KEYS.WAGES_TABLE_PAGE_SETTINGS, JSON.stringify(values));
    }

    if (action.type === SET_CALENDAR_PAGE_FILTER) {
        const values = store.getState().calendarPage;
        localStorage.setItem(LOCAL_STORAGE_KEYS.WAGES_CALENDAR_PAGE_SETTING, JSON.stringify(values));
    }

    if (action.type === SET_WAGES_PARAMS_SELECTION_MODE_ENABLED) {
        const flag = store.getState().wagesParamsSelectionModeEnabled;
        localStorage.setItem(LOCAL_STORAGE_KEYS.WAGES_PARAMS_SELECTION_MODE_ENABLED, flag);
    }

    return result;
};


export default settingsMiddleware;
